import React from 'react';
import { FormControlLabel, Radio, TextField } from '@material-ui/core';
import { $contains, $eq, $sw, $ew, $empty } from '../operators';
import { FilterForm, useFilterFormActions } from './filter-form';
import { mergeOverride } from './override-operator';

export const StringFilters = props => (
  <FilterForm {...props} radioFilters={StringFilterFormItems} />
);

function StringFilterFormItems({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );

  return (
    <>
      {[$contains, $eq, $sw, $ew].map(mergeOverride(column.overrideOperator)).map(e => (
        <React.Fragment key={e.key}>
          <FormControlLabel
            value={e.key}
            control={<Radio />}
            label={
              <TextField
                onClick={handleInputClick}
                inputRef={form.register}
                name={e.key}
                disabled={getRadioValue() !== e.key}
                variant="outlined"
                size="small"
                label={e.label}
              />
            }
          />
          <br />
        </React.Fragment>
      ))}
      <FormControlLabel
        value="false"
        control={<Radio />}
        label="Has a value."
        name="$empty"
        inputRef={form.register}
      />
      <FormControlLabel
        value="true"
        control={<Radio />}
        label="Does not have a value."
        name="$empty"
        inputRef={form.register}
      />
    </>
  );
}
